
export const sleep = duration => new Promise(resolve => {
  window.setTimeout(() => resolve(duration), duration);
});